// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U_cv","colMin":"styles_colMin__2JwsW"};